import { NgModule } from "@angular/core";
import { CardHeaderComponent } from "./card-header.component";

@NgModule({
    imports: [],
    declarations: [
        CardHeaderComponent
    ],
    exports: [
        CardHeaderComponent
    ]
})
export class CardHeaderModule { }